/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Continue_TrialInputs */

const en_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue Trial`)
};

const fr_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer l’essai`)
};

const de_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortsetzung des Verfahrens`)
};

const it_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua la prova`)
};

const ru_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить судебное разбирательство`)
};

const es_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar la prueba`)
};

const zh_cn2_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续审判`)
};

const ja_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルを続ける`)
};

const hi_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सतत् परीक्षण`)
};

const pt_pt2_work_order_publish_continue_trial = /** @type {(inputs: Work_Order_Publish_Continue_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar o julgamento`)
};

/**
* | output |
* | --- |
* | "Continue Trial" |
*
* @param {Work_Order_Publish_Continue_TrialInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_continue_trial = /** @type {((inputs?: Work_Order_Publish_Continue_TrialInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Continue_TrialInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_continue_trial(inputs)
	if (locale === "de") return de_work_order_publish_continue_trial(inputs)
	if (locale === "it") return it_work_order_publish_continue_trial(inputs)
	if (locale === "ru") return ru_work_order_publish_continue_trial(inputs)
	if (locale === "es") return es_work_order_publish_continue_trial(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_continue_trial(inputs)
	if (locale === "ja") return ja_work_order_publish_continue_trial(inputs)
	if (locale === "hi") return hi_work_order_publish_continue_trial(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_continue_trial(inputs)
	return en_work_order_publish_continue_trial(inputs)
});